import React, { useContext, useLayoutEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { GlobalContext } from "../../../context/GlobalContext";
import dayjs from "dayjs";

export default function Birthday() {
    const { state, dispatch } = useContext(GlobalContext);
    // No default date — a borrower's date of birth is never "today", so
    // this field starts genuinely empty (null) until they pick one,
    // instead of silently pre-filling (and pre-validating) a date nobody
    // actually chose.
    const [dob, setDob] = useState(
        state?.questions?.dob ? dayjs(reformatDate(state?.questions?.dob)) : null
    )
    const inputRef = useRef();
    function extractDateFromDateObject(dateObject) {
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11, so add 1
        const day = String(dateObject.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    function reformatDate(inputDate) {
        const dateObject = new Date(inputDate);

    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const year = dateObject.getFullYear();

    const formattedDate = `${month}-${day}-${year}`;

        return formattedDate;
    }
    // useLayoutEffect (not useEffect) is load-bearing here: it runs
    // synchronously right after the DOM commits, before the browser paints —
    // so the mount-time dispatch below is guaranteed to have already landed
    // in global state before the user can see or interact with this field.
    // A plain useEffect fires after paint, leaving a real (if usually brief)
    // window where the picker displays a value that Continue's validation —
    // reading straight from global state — wouldn't see yet, exactly the
    // "fails on first click, passes on the second try" bug this fixes.
    useLayoutEffect(() => {
        // Nothing chosen yet — don't dispatch a "no selection" value as if
        // it were a real answer (state.questions.dob's own "" default
        // already correctly fails validation until the borrower picks one).
        if (!dob) return;
        const dateObject = new Date(dob);
        let obj = { ...state.questions };
        obj.dob = extractDateFromDateObject(dateObject)
        dispatch({
          type: "QUESTIONS",
          payload: obj,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dob]);
    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [])
    return (
        <div className="pd6-dob-field">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    ref={inputRef}
                    label={null}
                    value={dob}
                    onChange={(newValue) => setDob(newValue)}
                    maxDate={dayjs()}
                    slotProps={{
                        textField: {
                            fullWidth: true,
                            variant: "outlined",
                            placeholder: "MM/DD/YYYY",
                        },
                    }}
                />
            </LocalizationProvider>
        </div>
    );
}
